module.exports = __webpack_public_path__ + "static/media/saturn-1.919cbffa.jpg";